import React, { ReactElement, useState, useEffect } from "react";
import { connect } from "react-redux";
import Drawer from "../../../Common/Drawer/Drawer";
import * as types from "../../../../constants/actionTypes";
import Notification from "../../../Common/Notification";
import MultiSelectBox from "../../../Common/MultiSelectBox/MultiSelectBox";

interface Location {
    id: number;
    name: string;
    locationKey: string;
}

interface User {
    userId: number;
    firstName: string;
    lastName: string;
    jobTitle: string;
}

interface LocationContactImporterProps {
    locationActions: any;
    locationContactActions: any;
    onComplete: () => void;
    onCancel: () => void;
    locationKey: string;
}

const LocationContactImporter = ({
    locationContactActions,
    locationActions,
    onComplete,
    onCancel,
    locationKey,
}: LocationContactImporterProps): ReactElement => {
    const [locations, setLocations] = useState<Array<Location>>([]);
    const [selectedLocationKey, setSelectedLocationKey] = useState<string>("");
    const [usersToImport, setUsersToImport] = useState<Array<User>>([]);

    useEffect(() => {
        search('');
    }, []);

    const search = async (name: string) => {
        const fetchData = async () => {
            try {
                const result = await locationActions.searchLocations({ Name:name, IsActive: true, SortBy: "name", PageSize: 100 });
                const payload = result.payload;
                if (result.type === types.SEARCH_LOCATION_SUCCESS) {
                    setLocations(payload.results);
                } else if (result.type === types.SEARCH_LOCATION_FAILURE) {
                    Notification("error", "An Error Occurred", payload.message);
                }
            } catch (error) {
                console.error("Error:", error);
            }
        };

        fetchData();
    };

    const contactsToImport = async (selectedLocationKey: string) => {
        const fetchData = async () => {
            try {
                const result = await locationContactActions.contactsToImport(selectedLocationKey, locationKey);
                const payload = result.payload;
                if (result.type === types.CONTACTS_TO_IMPORT_SUCCESS) {
                    setUsersToImport(payload.results)
                    if(payload.results.length == 0)
                    {
                        Notification("error", "Users not found", "Users not available for import");
                    }
                } else if (result.type === types.CONTACTS_TO_IMPORT_FAILURE) {
                    Notification("error", "An Error Occurred", payload.message);
                }
            } catch (error) {
                console.error("Error:", error);
            }
        };

        fetchData();
    };

    const importContacts = async() => {
        const fetchData = async () => {
            try {
                const result = await locationContactActions.import(selectedLocationKey, locationKey);
                const payload = result.payload;
                if (result.type === types.IMPORT_CONTACTS_SUCCESS) {
                    onComplete();
                    Notification("success", "", "Location Contact Imported Successfully");
                } else if (result.type === types.IMPORT_CONTACTS_FAILURE) {
                    Notification("error", "An Error Occurred", payload.message);
                }
            } catch (error) {
                console.error("Error:", error);
            }
        };

        fetchData();
    };


    const onChange = (locationKey: string): void => {
        const found = locations.find((obj) => {
            return obj.locationKey === locationKey;
        });

        if (found !== undefined) {
            setSelectedLocationKey(locationKey);
            contactsToImport(locationKey);
        } 
        else {
            setSelectedLocationKey("");
        }        
    };

    const onInputChange = (name: string): void => {
        search(name);
    };

    const onImport = () => {

        if(usersToImport.length == 0)
        {
            Notification("error", "Users not found", "Users not available for import");
        }
        else
        {
            importContacts();
        }  
    };

    return (
        <Drawer
            isOpen={true}
            isWide={false}
            title="Import Location Contact"
            saveText="Import"
            onCancelClick={onCancel}
            onSaveClick={onImport}
        >
            <MultiSelectBox
                name="locationId"
                label="Select the source location"
                data-testid="multiSelectBox"
                options={locations}
                idField="locationKey"
                valueField="name"
                selectedValues={selectedLocationKey}
                onChange={onChange}
                onInputChange={onInputChange}
                isRequired={true}
                errorMessage="Location is required"
                isMulti={false}
            />

                <table className="table table-striped table-bordered table-hover">
                    <tbody>
                        {
                            usersToImport.length > 0 &&
                            usersToImport.map(contact => {
                                return (
                                    <tr key={contact.userId}>
                                        <td>{contact.firstName} {contact.lastName}</td>
                                        <td>{contact.jobTitle}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
        </Drawer>
    );
};

export default connect(null, null)(LocationContactImporter);
